import React from 'react'

const Darts = ({ width = '24px', height = '25px', fill = '#fff' }) => {
  return (
    <svg style={{ width, height, fill }} viewBox='0 0 24 25' version='1.1'>
      <title>Darts</title>
      <g id='Pre-Reg-Landing-Page' stroke='none' strokeWidth='1' fillRule='evenodd'>
        <g id='Desktop-10-Copy' transform='translate(-734.000000, -527.000000)' fillRule='nonzero'>
          <g id='onboarding/sport-copy-21' transform='translate(693.000000, 503.000000)'>
            <g id='icon/16/sport/darts/dartboard' transform='translate(41.000000, 24.089286)'>
              <path
                d='M18,0 L19.5,4.5 L24,6 L19.5,10.5 L16.5,9.6 L16.136,9.454 L15.1462558,10.4447402 C16.1830359,11.8017644 16.8174194,13.4826348 16.871271,15.3092159 L16.875,15.5625 C16.875,20.2224026 13.0974026,24 8.4375,24 C3.77759742,24 8.52651283e-14,20.2224026 8.52651283e-14,15.5625 C8.52651283e-14,10.9025974 3.77759742,7.125 8.4375,7.125 C10.3623012,7.125 12.1365675,7.76951605 13.5562571,8.85450619 L14.575,7.834 L14.4,7.35 L13.5,4.5 L18,0 Z M8.4375,9.375 C5.02023811,9.375 2.25,12.1452381 2.25,15.5625 C2.25,18.9797619 5.02023811,21.75 8.4375,21.75 C11.8547619,21.75 14.625,18.9797619 14.625,15.5625 C14.625,14.2601216 14.2226213,13.0517237 13.5353999,12.0548424 L8.625,16.965 L7.035,15.375 L11.9451576,10.4646001 C10.9482763,9.77737868 9.73987842,9.375 8.4375,9.375 Z'
                id='path'
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Darts
